export * from './LeftAligned';
